export enum ThirdPartyIntegrationType {
  TopDesk = 'topdesk',
  Zendesk = 'zendesk',
  Sharepoint = 'sharepoint',
  SharepointPages = 'sharepoint_pages',
  Rompslomp = 'rompslomp',
  EmailStudio = 'email_studio',
}
